import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../../../../core/Icon';
import mediaqueries from '../../../../../config/themes/variables/mediaqueries';

export const StyledWrapWidget = styled.div`
  padding: ${rem('8px')} ${rem('10px')} ${rem('24px')} ${rem('10px')};
`;

export const StyledText = styled.p`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.small};
  text-align: center;
  line-height: 1;
`;

export const StyleWrapResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${rem('-4px')};
  ${mediaqueries.greaterThan('mobile')`
    padding: 0 ${rem('20px')};
  `};
`;

export const StyleIconWidget = styled(Icon)`
  height: 2.8rem;
  width: 2.8rem;
`;

export const StyledStatus = styled.div`
  padding: 0 ${rem('4px')};
  text-align: center;
`;

export const StyledTemp = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${rem('28px')};
  padding: 0 ${rem('4px')};
  min-width: ${rem('60px')};
`;

export const StyledTempMaxMin = styled.span`
  font-family: ${props => props.theme.fonts.regular};
  font-size: ${rem('12px')};
  line-height: ${rem('12px')};
  padding-top: ${rem('3px')};
`;

export const StyledDescription = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('12px')};
  line-height: 1;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledIcon = styled(Icon)`
  float: right;
  margin: 0.1rem 0 0.1rem 0.3rem;
  &:hover {
    fill: ${props => props.theme.colors.light};
  }
  padding-left: ${rem('3px')};
`;

export const StyleLoading = styled.div`
  display: flex;
  font-size: 11px;
  justify-content: flex-end;
  align-content: flex-end;
`;
